export const BACKEND_URL = 'https://bermillo.realpropertydata.ca/backend/';
